var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.expired)?_c('button',{staticClass:"btn btn-secondary",class:{ loading: _vm.cancellingReservedAppointment },attrs:{"type":"button","role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.sendCancelReservedAppointmentRequest.apply(null, arguments)}}},[_vm._v("Change appointment")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }